
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectCreative, Parallax } from 'swiper/modules';

// CSS separat:
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// init Swiper:
const swiper = new Swiper('.swiper', {
    modules: [Navigation, Pagination, Autoplay, EffectCreative, Parallax],

    // Optional parameters
    direction: 'horizontal',
    loop: true,
    grabCursor: true,

    //effect: "cards",
    effect: "creative",
    speed: 600,
    parallax: true,

    autoplay: {
        delay: 8000,
        disableOnInteraction: true,
    },

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    creativeEffect: {
        //perspective: true,

        prev: {
            //shadow: true,
            opacity: 0,
            translate: ["-10%", 0, -200],
            //translate: ["-86.6%", 0, 0],
            //rotate: [0, 20, 0],
        },
        next: {
            opacity: 0,
            translate: ["10%", 0, -200],
            //translate: ["86.6%", 0, 0],
            //rotate: [0, -10, 0],
        },
    },

    /*
    watchSlidesProgress: true,
    on: {
        // Während der Transition: interpolieren wir die Opacities anhand des slide.progress
        setTranslate: function() {
            this.slides.forEach((slide, index) => {
                const progress = slide.progress;
                console.log(progress)
                if (index === this.activeIndex) {
                    if (Math.abs(progress) < 0.5) {
                        let factor = Math.abs(progress) / 0.5;
                        slide.style.opacity = 1 - factor * (1 - 0.33);
                        slide.style.zIndex = 1;
                        console.log("a")
                    }
                }
                else if (Math.abs(progress) < 1) {
                    if (Math.abs(progress) > 0.5) {
                        let factor = (1 - Math.abs(progress)) / 0.5;
                        slide.style.opacity = factor * 0.5;
                        slide.style.zIndex = 0;
                        console.log("b")
                    }
                }
            });
        },
    }
    */
});